import { WidgetConfigs } from './types/widget.interface';
import { AerosyncEnvironment } from './types/environment';
import { AerosyncWidget } from './Aerosync';

export function initAeroSyncWidget(widgetConfigs: WidgetConfigs): AerosyncWidget {
      const aerosyncWidget = new AerosyncWidget(widgetConfigs);
      window.AerosyncWidget = aerosyncWidget
      return aerosyncWidget;
}

export const initWidget = initAeroSyncWidget;

export * from './types/event.interface'
export * from './types/widget.interface'
export type { WidgetConfigs, AerosyncWidget };
export { AerosyncEnvironment }